import React, { Component } from 'react';
import { fetchSamples } from '../helper/api';
import connect from 'react-redux/es/connect/connect';
import moment from 'moment-timezone';
import DataToSankeyChart from '../helper/DataToSankeyChart';
import SankeyChart from '../components/charts/SankeyChart';
import { setSankeyColumnFilter } from '../actions/sankeyColumnFilter';
import { setQueryParams } from '../actions/queryParams';
import { withRouter } from 'react-router-dom';
import {
  setSankeyOptionsCosts,
  setSankeyOptionsValues
} from '../actions/sankeyOptions';
import { filterSensorsByLoggerId } from '../helper/DataToChart';
import { setAppLoadingSamples } from '../actions/loading';
import { API_RESPONSE_NO_DATA } from '../constants/actionMessages';

class SankeyWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      samples: {},
      isLoading: false,
      data: {
        nodes: [],
        links: [],
        headers: []
      }
    };
  }

  async requestSamples({
    siteId,
    loggerId,
    loggers,
    sensors,
    queryParams,
    queryParams: { aggregationLevel },
    sankeyColumnFilter,
    setAppLoadingSamples
  }) {
    if (!siteId || !sensors) {
      return;
    }

    setAppLoadingSamples(true);
    const { isLoading } = this.state;

    if (isLoading) {
      return;
    }

    this.setState({ isLoading: true });

    // override aggregationLevel
    queryParams.aggregationLevel = 'hours_1';

    if (loggerId) {
      sensors = filterSensorsByLoggerId({ sensors, loggerId });
    }

    const { samples } = await fetchSamples({
      siteId,
      loggerId,
      queryParams,
      isSankeyData: true
    });
    const data = await DataToSankeyChart({
      sensors,
      samples,
      aggregationLevel,
      loggers,
      loggerId,
      groups: sankeyColumnFilter
    });

    this.setState({ samples, isLoading: false, data, emptyResponse: !samples });
    setAppLoadingSamples(false);
  }

  componentWillMount() {
    const newQueryParams = {
      from: moment()
        .startOf('day')
        .subtract(7, 'day')
        .unix(),
      to: moment()
        .startOf('day')
        .unix(),
      aggregationLevel: 'days_1'
    };

    const samplesQueryParamsChanged =
      newQueryParams.from !== this.props.queryParams.from ||
      newQueryParams.to !== this.props.queryParams.to ||
      newQueryParams.aggregationLevel !==
        this.props.queryParams.aggregationLevel;

    if (samplesQueryParamsChanged) {
      this.props.setQueryParams(newQueryParams);
      return;
    }

    const loggerId = this.props.match.params.loggerId;
    this.requestSamples({ ...this.props, loggerId });
  }

  componentWillReceiveProps(nextProps) {
    const loggerId = nextProps.match.params.loggerId;
    const loggerIdChanged = loggerId !== this.props.match.params.loggerId;
    const { queryParams, sensors, sankeyColumnFilter } = nextProps;
    const samplesQueryParamsChanged =
      queryParams.from !== this.props.queryParams.from ||
      queryParams.to !== this.props.queryParams.to ||
      queryParams.aggregationLevel !== this.props.queryParams.aggregationLevel;
    const sensorsChanged =
      !sensors ||
      !this.props.sensors ||
      sensors !== this.props.sensors ||
      Object.keys(sensors).length !== Object.keys(this.props.sensors).length;
    const sankeyColumnsChanged =
      JSON.stringify(sankeyColumnFilter) !==
      JSON.stringify(this.props.sankeyColumnFilter);

    if (
      samplesQueryParamsChanged ||
      sensorsChanged ||
      loggerIdChanged ||
      this.state.samples === {}
    ) {
      this.requestSamples({ ...nextProps, loggerId });
    }

    if (sankeyColumnsChanged) {
      const data = DataToSankeyChart({
        sensors: loggerId
          ? filterSensorsByLoggerId({ sensors, loggerId })
          : sensors,
        samples: this.state.samples,
        aggregationLevel: nextProps.queryParams.aggregationLevel,
        groups: sankeyColumnFilter
      });
      this.setState({ data });
    }
  }

  render() {
    const { data, emptyResponse } = this.state;
    const {
      site,
      match,
      queryParams: { aggregationLevel },
      history,
      sankeyOptions,
      sankeyColumnFilter,
      setSankeyColumnFilter
    } = this.props;

    if (emptyResponse) {
      return <div>{API_RESPONSE_NO_DATA}</div>;
    }

    return (
      <div>
        <SankeyChart
          data={data}
          sankeyOptions={sankeyOptions}
          aggregationLevel={aggregationLevel}
          sankeyColumnFilter={sankeyColumnFilter}
          updateSankeyColumnFilter={setSankeyColumnFilter}
          cost={site ? site.cost : null}
          currency={site ? site.currency : null}
          match={match}
          history={history}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  loggers: state.loggers,
  sankeyOptions: state.sankeyOptions,
  sankeyColumnFilter: state.sankeyColumnFilter,
  siteId: state.site.id,
  site: state.site,
  sensors: state.sensors,
  queryParams: state.queryParams,
  groupFilterRelations: state.groupFilterRelations,
  timezone: state.site.timezone,
  utcOffset: moment.tz(state.site.timezone).utcOffset(),
  loading: state.loading.samples
});

export default connect(mapStateToProps, {
  setSankeyColumnFilter,
  setQueryParams,
  setSankeyOptionsCosts,
  setSankeyOptionsValues,
  setAppLoadingSamples
})(withRouter(SankeyWrapper));



// WEBPACK FOOTER //
// ./src/container/SankeyWrapper.js